module.exports = __webpack_public_path__ + "static/media/EmailEmployee.1be4bbe2.svg";